import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import useCardsShowHook from '../useHooks/useCardsShowHook';

function TheComp() {
    const { t } = useLang('costsaving-new');
    useCardsShowHook('.cost-saving-D', '.cost-saving-D');
    return (
        <section className={`cost-saving-D GtmModuleData-section`} id="cost-saving-D" data-section-id={'cost-saving-D'} data-section-title={t('D_title')}>
            <EcoSpace />
            <section
                className={`${css.section} cost-saving-D GtmModuleData-section`}
                id="cost-saving-D"
                data-section-id={'cost-saving-D'}
                data-section-title={t('D_title')}
            >
                <EcoImg
                    className='img'
                    pc="https://websiteoss.ecoflow.com/upload/image/1768186914398/full-width-carousel.jpg"
                    pad='https://websiteoss.ecoflow.com/upload/image/1768186915199/Frame%202094654834.jpg'
                    h5="https://websiteoss.ecoflow.com/upload/image/1768186913129/Frame%202094654776.jpg"
                    isOpenLazy
                />
                <div className="D-info">
                    <div className="D-title">{t('D_title')}</div>
                    <div className="D-subtitle">{t('D_subtitle')}</div>
                    <div className="D-desc">{t('D_desc')}</div>
                </div>
            </section>
        </section>
    );
}

export default TheComp;
